import React from 'react';
import type { MilestoneDeliveryStatus } from '../types';

interface MilestoneConflictActionButtonProps {
  deliveryStatus?: MilestoneDeliveryStatus;
  children: React.ReactNode;
  onClick: () => void;
  compact?: boolean;
  dataTestId?: string;
  /** A quiet outline button, e.g. for an external dispute the viewer can only look at. */
  neutral?: boolean;
}

/** Shared primary CTA for opening an active milestone objection or dispute. */
export function MilestoneConflictActionButton({
  deliveryStatus,
  children,
  onClick,
  compact = false,
  dataTestId,
  neutral = false
}: MilestoneConflictActionButtonProps) {
  const isExternalDispute = deliveryStatus === 'external_dispute';
  const tone = neutral ? 'btn-outline-secondary' : isExternalDispute ? 'btn-danger fw-semibold shadow-sm' : 'btn-warning fw-semibold shadow-sm';

  return (
    <button
      type="button"
      className={`btn ${compact ? 'btn-sm' : ''} ${tone} d-inline-flex align-items-center flex-shrink-0`}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <i className={`feather-${isExternalDispute ? 'file-text' : 'message-circle'} me-1`} />
      {children}
    </button>
  );
}
